import { isStreamIQ, isToya } from '@/shared/lib'

export async function getChannel() {
    if (isToya()) {
        try {
            const module =
                // eslint-disable-next-line @typescript-eslint/no-var-requires
                await require('@/clients/toya/classes/channels/channel')
            return module.default
        } catch (error) {
            console.warn(
                'Channel module is missing. TOYA-specific features are disabled.',
                error
            )
            return null
        }
    }
    if (isStreamIQ()) {
        try {
            const module =
                // eslint-disable-next-line @typescript-eslint/no-var-requires
                await require('@/clients/streamiq/shared/classes/StreamIqChannel')
            return module.StreamIQChannel
        } catch (error) {
            console.warn(
                'StreamIQChannel module is missing. StreamIQ-specific features are disabled.',
                error
            )
            return null
        }
    }
}
